"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.SIZE = exports.SHIMMER_DIMENTIONS = exports.ICON = exports.CURSOR = void 0;
var SHIMMER_DIMENTIONS = '10px';
exports.SHIMMER_DIMENTIONS = SHIMMER_DIMENTIONS;
var CURSOR = {
  DISABLED: 'not-allowed',
  POINTER: 'pointer'
};
exports.CURSOR = CURSOR;
var ICON = {
  REMOVE_ICON: 'RemoveIcon'
};
exports.ICON = ICON;
var SIZE = {
  SMALL: 'small'
};
exports.SIZE = SIZE;
var TRANSLATION = {
  soldOut: 'Sold out',
  view: 'View'
};
exports.TRANSLATION = TRANSLATION;